import { Container } from 'inversify-props';
import setupFixedTimeCalculation
  from '@/modules/flagship/emergency-fund-calculations/fixed-time-calculation/setup';

export default function setupEmergencyFundCalculations(container: Container) {
  setupFixedTimeCalculation(container);
}
